// ------ plugin import ------- //
import React,{useState, useEffect} from 'react'
import axios from 'axios'
import Flatpickr from "react-flatpickr";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate,faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import "flatpickr/dist/plugins/monthSelect/style.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { TimeRangePickerProps } from 'antd';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';

import CreditReportList from './CreditReportList'
import CreditReportSkeleton from './CreditReportSkeleton'
import Pagination from '../../../../component/common/pagination/Pagination'
import NoDataFound from '../../../../component/common/NoDataFound';

const { RangePicker } = DatePicker;

const rangePresets: TimeRangePickerProps['presets'] = [
    { label: 'Last 7 Days', value: [dayjs().add(-7, 'd'), dayjs()] },
    { label: 'Last 14 Days', value: [dayjs().add(-14, 'd'), dayjs()] },
    { label: 'Last 30 Days', value: [dayjs().add(-30, 'd'), dayjs()] },
    { label: 'Last 90 Days', value: [dayjs().add(-90, 'd'), dayjs()] },
];

const CreditReport = (props) => {

    const {isCreditAdded} = props;

    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    // ----- define all state here ----- //
    const [page, setPage] = useState(1);
    const [creditReportData, setCreditReportData] = useState([]);
    const [paginationData, setPaginationData] = useState({});
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [monthYear, setMonthYear] = useState(() => {
        const now = new Date();
        const month = now.getMonth() + 1;
        const year = now.getFullYear();
        return `${year}-${month < 10 ? "0" + month : month}`;
    });
    const [showIsLoader, setShowIsLoader] = useState(true);
    const [searchButtonLoader, setSearchButtonLoader] = useState(false);
    const [dateState, setDateState] = useState({
        startDate: dayjs().startOf('day'),
        endDate: dayjs().endOf('day')
    });

    const [exportDateSelectPopup, setExportDateSelectPopup] = useState('')
    
    const getDataLimit = 50;

    const getCreditReport = async () => {
        setShowIsLoader(true)
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        let reqData = {
            page: page,
            limit: getDataLimit,
            search_date: monthYear,
            sass_id: localStorage.getItem('sass_id')
        }
        await axios.post(`${api_base_url}admin/get-credit-report`, reqData, api_headers)
        .then(async (res) => {
            console.log(res)
            if(res.data.status === 'success') {
                setCreditReportData(res.data.data.data)
                setPaginationData({
                    current_pages : res.data.data.current_pages,
                    total_data_count : res.data.data.total_count,
                    total_pages : res.data.data.total_pages,
                    limit : res.data.data.limit,
                    data_length : res.data.data.data.length
                })
            } else if(res.data.status === 'error') {
                console.error('error')
            }
            setShowIsLoader(false)
            setSearchButtonLoader(false)
        })
        .catch((error) => {
            setShowIsLoader(false)
            setSearchButtonLoader(false)
            console.error(error);
        })
    };

    useEffect(() => {
        getCreditReport()
    }, [page, isCreditAdded]);
   

    let creditReportHtml = ``;
    if(creditReportData.length > 0){
        creditReportHtml = creditReportData.map((creditDataReport, index) => 
            <CreditReportList
                key={index}
                creditReport={creditDataReport}
            />
        )
    }

    const pagechangeHandler = (pageNumber, type) => {
        if( type === 'previous' ){
            setPage((c_page) => c_page - 1)
        }else if( type === 'page' ){
            setPage(pageNumber)
        }
        else if( type === 'next' ){
            setPage((c_page) => c_page + 1)
        }
    }

    const handleDateChange = ([date]) => {
        if (date) {
            setSelectedDate(date);
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            setMonthYear(`${year}-${month < 10 ? "0" + month : month}`);
        }
    };
    const hasData = creditReportData.length > 0;
    const noData = !showIsLoader && !hasData;

    // --------- export section ---------- //
    const onRangeChange = (dates, dateStrings) => {
        if (dates) {
            setDateState((prevState)=>{
                return {
                    ...prevState,
                    startDate: dates[0],
                    endDate: dates[1]
                }
            })
        } else {
            setDateState((prevState)=>{
                return {
                    ...prevState,
                    startDate: null,
                    endDate: null
                }
            })
        }
    };

    let exportLimit = 1000;
    let exportPage = 0;

    const exportCreditSummaryReport = async(reqParam) => {
        reqParam.export_page = exportPage;
        reqParam.export_limit = exportLimit;
        reqParam.type = 'data_export';
        reqParam.total_row = reqParam.total_row;
        var outputPath = '';
        if(reqParam.output_path){
            outputPath = reqParam.output_path;
        }
        reqParam.output_path = outputPath;
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        await axios.post(`${api_base_url}admin/credit-summary-report-export`, reqParam, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                var processedRow = res.data.data.processedRows;
                var totalRow = reqParam.total_row;
                var percentage = (processedRow / totalRow) * 100;
                var roundPer = Math.round(percentage);
                const completedCount = document.querySelector('.completed-count');
                if (completedCount) {
                    completedCount.innerText = processedRow;
                }
                if(exportPage < res.data.data.total_page ){
                    exportPage = exportPage + 1;
                    exportCreditSummaryReport({
                        start_date: formDate.startDate,
                        end_date: formDate.endDate,
                        output_path : res.data.data.outputPath,
                        export_type : reqParam.export_type,
                        total_row : reqParam.total_row
                    });
                    const percentageHtml = document.querySelector('.set-percentage');
                    if(percentageHtml){
                        percentageHtml.innerText = (roundPer+'%');
                    }
                    const progressBarHtml = document.querySelector('.complete-progress-bar');
                    if(progressBarHtml){
                        progressBarHtml.style.width = `${percentage}%`;
                    }
                }
                else{
                    const completeCountHtml = document.querySelector('.completed-count');
                    completeCountHtml.innerText = (totalRow);
                    const percentageHtml = document.querySelector('.set-percentage');
                    percentageHtml.innerText = ('100%');
                    const progressBarHtml = document.querySelector('.complete-progress-bar');
                    progressBarHtml.style.width = `100%`;
                    const exportProcessImage = document.querySelector('.export-process-img');
                    exportProcessImage.src = '/media/saiMedia/sai-complete.gif';
                    const exportProcessHtml = document.querySelector('.export-process-msg');
                    exportProcessHtml.innerText = `Export process has been finished`;
                    exportPage = 0;
                    var folder_path = res.data.data.zip_folder_path;
                    var folder_name = res.data.data.zip_folder_name;
                    const filePath = `${api_base_url}api/any-file-download?file_path=${folder_path}&file_name=${folder_name}&file_is_delete=yes`;
                    window.location.href = filePath;
                    let okButtonHtml = `
                        <button type="button" class="btn btn-dark mb-5" id="progress_swal_ok_btn">
                            OK
                        </button>
                    `;
                    const okButtonEle = document.querySelector('.swal-close-btn');
                    okButtonEle.innerHTML = okButtonHtml;
                    const okBtn = document.querySelector('#progress_swal_ok_btn');
                    if (okBtn) {
                        okBtn.addEventListener('click', () => {
                            Swal.close();
                        });
                    }
                }
         
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    let formDate = {};
    const exportOnClick = async() => {
        if(dateState){
            if(dateState.startDate) {
                var start_date = new Date(dateState.startDate).toLocaleString("en-GB");
                var split_start_data = start_date.split(", ");
                const [day, month, year] = split_start_data[0].split('/');
                const formattedStartDate = `${year}-${month}-${day}`;
                formDate.startDate = formattedStartDate
            }
            if(dateState.endDate) {
                var end_date = new Date(dateState.endDate).toLocaleString("en-GB");
                var split_end_data = end_date.split(", ");
                const [day, month, year] = split_end_data[0].split('/');
                const formattedEndDate = `${year}-${month}-${day}`;
                formDate.endDate = formattedEndDate
            }
        }
        setExportDateSelectPopup('');

        var setHtml = `
            <div class="row">
                <div class=col-md-12>
                    <div class="text-center my-4 export-process-img" style="">
                        <img src="/media/saiMedia/sai-export-data.gif" class="w-25">
                    </div>
                    <div class="d-flex align-items-center  flex-column mt-3">
                        <div class="d-flex justify-content-between w-100 mt-auto mb-2">
                            <span class="fw-semibold fs-6 export-process-msg">
                                Export process is underway
                            </span>
                            <span class="fw-bold fs-6 set-percentage">0%</span>
                        </div>
                        <div class="h-10 px mx-3 w-100 bg-light mb-3">
                            <div class="bg-info rounded h-10px complete-progress-bar" role="progressbar" style="width: 0%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <p class="badge me-auto badge-light-dark pe-3 mb-0 mt-5 m-auto">
                            <span class="badge badge-dark me-3">
                                <span class=completed-count>0</span>/<span class=total-count>0</span>
                            </span>
                            records exported
                        </p>
                        <div class="align-items-center d-flex flex-column mt-5 swal-close-btn">
                        </div>
                    </div>
                </div>    
            </div>
        `;
        Swal.fire({
            html: setHtml,
            showCancelButton: false,
            showConfirmButton : false,
        });

        let reqData = {
            type: 'data_count',
            start_date: formDate.startDate,
            end_date: formDate.endDate
        }

        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        await axios.post(`${api_base_url}admin/credit-summary-report-export`, reqData, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                let _totalDataCount = Number(res.data.data.total_data_count[0].count);

                let _exportType = 'single';
                if(_totalDataCount > exportLimit){
                    _exportType = 'multiple';
                }
                const totalCountElem = document.querySelector('.total-count');
                if (totalCountElem) {
                    totalCountElem.innerText = _totalDataCount;
                }
                exportCreditSummaryReport({
                    start_date: formDate.startDate,
                    end_date: formDate.endDate,
                    export_type : _exportType,
                    total_row : parseInt(_totalDataCount)
                });
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    return (
        <>
            <div className="row mt-5">
                <div className="col-md-12">
                    <div className="card card-flush border">
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800">
                                    Credit Summary Report
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total {paginationData.total_data_count ? paginationData.total_data_count : 0} details are available
                                </span>
                            </h3>
                            <div className="card-toolbar">
                                <div className='d-flex flex-stack flex-wrap me-2'>
                                    <div className="input-group">
                                        <Flatpickr
                                            className='form-control'
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                            options={{
                                                dateFormat: "F Y",
                                                plugins: [
                                                    monthSelectPlugin({
                                                        shorthand: true,
                                                        dateFormat: "F Y",
                                                        altFormat: "F Y",
                                                    })
                                                ]
                                            }}
                                        />
                                        <span 
                                            className="input-group-text" 
                                            onClick={()=> {
                                                setSearchButtonLoader(true)
                                                getCreditReport()
                                            }}>
                                            {
                                                searchButtonLoader ? 
                                                <FontAwesomeIcon icon={faArrowsRotate} className='fs-3 fa-spin' />
                                                :
                                                <FontAwesomeIcon icon={faMagnifyingGlass} className='fs-3'/>
                                            }
                                        </span>
                                    </div>
                                </div>
                                {
                                    hasData && (
                                        <button 
                                            className="btn btn-warning"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                            data-sai-menu-backdrop="false"
                                            onClick={() => (setExportDateSelectPopup('show'))}
                                        >
                                            Export
                                        </button>
                                    )
                                }
                                <div 
                                    className={`menu menu-sub menu-sub-dropdown w-500px w-md-500px p-3 ${exportDateSelectPopup}`}
                                    data-sai-menu="true"
                                    data-sai-menu-backdrop="false"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div className='row m-2'>
                                        <div className='col-md-12'>
                                            <RangePicker
                                                presets={[
                                                    {
                                                        label: <span aria-label="Current Time to End of Day">To day</span>,
                                                        value: () => [dayjs().startOf('day'), dayjs().endOf('day')],
                                                    },
                                                    ...rangePresets,
                                                ]}
                                                defaultValue={[dateState.startDate, dateState.endDate]}
                                                format="YYYY-MM-DD"
                                                onChange={onRangeChange}
                                                allowClear={false}
                                            />
                                        </div>
                                        <div className='col-md-12 text-end mt-3'>
                                            <button 
                                                className="btn btn-dark btn-sm"
                                                onClick={exportOnClick}
                                            >
                                                Export
                                            </button>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body py-0">
                            <div id="sai_table_users_wrapper" className="dataTables dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    {showIsLoader && <CreditReportSkeleton totalRow={10} />}
                                    {hasData && (
                                        <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                                            <thead>
                                                <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                                                    <th className="w-300px sorting">Date</th>
                                                    <th className="w-300px sorting">Services</th>
                                                    <th className="w-300px sorting">Uses services</th>
                                                    <th className="w-250px sorting">Debit / Credit</th>
                                                    <th className="w-250px sorting text-end">Credit Activity</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-gray-600 fw-semibold">
                                                {creditReportHtml}
                                            </tbody>
                                        </table>
                                    )}
                                    {noData && (
                                        <NoDataFound
                                            setHtml="Summary Report Not Found"
                                            className="w-30"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {creditReportData.length > 0 && 
                <Pagination
                    pagination_data={paginationData}
                    onClick={pagechangeHandler}
                />
            } 
        </>
    )
}

export default CreditReport